export enum AvailableFeatureFlags {
  MapboxDistanceMatrices = 'MapboxDistanceMatrices',
  MapboxAutocomplete = 'MapboxAutocomplete',
  AuthorizeDotNet = 'AuthorizeDotNet',
  HasAccessToTransitionFeatures = 'HasAccessToTransitionFeatures',
  FranchiseSupport = 'FranchiseSupport',
  BetaFeatures = 'BetaFeatures',
  CrewAppBaseTipping = 'CrewAppBaseTipping',
  MoverAssociationExperience = 'MoverAssociationExperience',
  CustomerPortalTemplates = 'CustomerPortalTemplates',
  SmartScout = 'SmartScout',
  Enable400ngTariff = 'Enable400ngTariff',
  NewDispatchTripsTab = 'NewDispatchTripsTab',
  AdvancedCalendarSync = 'AdvancedCalendarSync',
  GoogleCalLocalizationFix = 'GoogleCalLocalizationFix',
  StorageInventoryScanning = 'StorageInventoryScanning',
  NewReferralChannelUX = 'NewReferralChannelUX',
  DarkMode = 'DarkMode',
  SyncPackingForDescriptiveInventory = 'SyncPackingForDescriptiveInventory',
  NewFormDesign = 'NewFormDesign',
  SmsOptInConsent = 'SmsOptInConsent',
  PreAuthorization = 'PreAuthorization',
  UnifiedPaymentSettings = 'UnifiedPaymentSettings',
  HomeDashboardBranchFilter = 'HomeDashboardBranchFilter',
  OfferCardOnFile = 'OfferCardOnFile',
  PreAuthorizationManualOverride = 'PreAuthorizationManualOverride',
  TabbedPaymentOpportunities = 'TabbedPaymentOpportunities',
  CrewAppWarehousing = 'CrewAppWarehousing',
  NestedRefundRows = 'NestedRefundRows',
  QuickBooksLineItemIntegration = 'QuickBooksLineItemIntegration',
  MobileOcean = 'MobileOcean',
  HourRangeEstimate = 'HourRangeEstimate',
  EcheckBackupPayment = 'EcheckBackupPayment',
  TvInternet = 'TvInternet',
  DispatchSlotHolds = 'DispatchSlotHolds',
  JobNoteTemplates = 'JobNoteTemplates',
  PaymentAuthorizationAgreements = 'PaymentAuthorizationAgreements',
  InternationalAddressLookup = 'InternationalAddressLookup',
  TravelTimeOncePerJob = 'TravelTimeOncePerJob',
  CommercialCommunications = 'CommercialCommunications',
  CrewCapacityAvailability = 'CrewCapacityAvailability',
  FirstJobMaterialsCharge = 'FirstJobMaterialsCharge',
  MapboxDirections = 'MapboxDirections',
  ZoneBasedPricing = 'ZoneBasedPricing',
}
